angular.module('AppCtrl.service', ['AppCtrl.jobvite.service'])
// Define constants
.value('CONST', {
    Urls: {
        getMessages: window.jvUrls.source + '/action/user/messages/',
        deleteMessages: window.jvUrls.source + '/action/user/messages/delete'
    }
})
//Define service to fetch the messages.
.factory('getMessages', ['$http', 'CONST', function ($http, CONST) {
    return function (args) {
        if (typeof args == 'undefined') {
            args = {};
        }
        var _data = args;
        var _ajaxCall = '';
        var _type = !!args.type ? args.type : 'GET';
        //var _type =  'GET';
        //_data.output = 'json';    // get the output in json.
        if (!(_data.state)) {
            _data.state = 'x';
        }
        delete _data.type;
        var _httpObject = {};
        _httpObject.headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        _httpObject.method = _type;
        _httpObject.url = !!args.url ? args.url + '?_=' + (new Date()).getTime() : CONST.Urls.getMessages + '?_=' + (new Date()).getTime();
        _httpObject.params = _data;

        if (_httpObject.url.split('?')[0] === CONST.Urls.getMessages) {
            _ajaxCall = 'getMessages';
        } else if (_httpObject.url.split('?')[0] === window.jvUrls.source + '/action/user/messages/types') {
            _ajaxCall = 'getMessageTypes';
        } else if (_httpObject.url.split('?')[0] === CONST.Urls.deleteMessages) {
            _ajaxCall = 'deleteMessages';
        }
        if (typeof _gaq != 'undefined') {
            _gaq.push(['_trackEvent', window.JV.PAGE_TYPE, _ajaxCall, window._jvselfUser.companyEId]);
        }

        return $http(_httpObject);
    };
}])
// Service Exposed to all the controllers for getting and navigating through all the messages.
.factory('messageService', ['getMessages', '$rootScope', 'CONST', function (getMessages, $rootScope, CONST) {
    var messageService = {};
    messageService.filters = {};
    messageService.filters.inbox = true;
    messageService.sortyBy = '';
    messageService.inMessageIds = [];
    messageService.sentMessageIds = [];
    messageService.eids = [];
    messageService.toFrom = 'From';

    messageService.getMessageTypes = function (_args) {
        var args = _args;
        args.url = window.jvUrls.source + '/action/user/messages/types';
        var _getMessages = getMessages(args);
        _getMessages.then(function (results) {
            $rootScope.$broadcast('messageTypes', results.data);
        });
    };

    messageService.getMessageList = function () {
        var _filters = this.filters;
        if ($rootScope.refresh === true) {
            _filters.refresh = true;
        }
        var _getMessages = getMessages(_filters);
        _getMessages.then(function (results) {
            $rootScope.$broadcast('messageResults', results.data, _filters.inbox);
        });
    };

    messageService.getMessagesDetails = function () {
        var _filters = this.filters;
        _filters.ids = true;
        if ($rootScope.refresh === true) {
            _filters.refresh = true;
        }
        var _getMessages = getMessages(_filters);
        _getMessages.then(function (results) {
            $rootScope.$broadcast('messageDetailResults', results.data);
        });
    };

    messageService.getNewMessages = function (routeParams) {
        routeParams.jvFolder = (routeParams.jvFolder === 'all') ? '' : routeParams.jvFolder;
        routeParams.jvMsgType = (routeParams.jvMsgType === 'all') ? '' : routeParams.jvMsgType;
        routeParams.jvState = (routeParams.jvState === 'all') ? '' : routeParams.jvState;
        routeParams.jvPage = (routeParams.jvPage === '') ? 0 : routeParams.jvPage;
        $rootScope.$broadcast('filterValues', routeParams);
    };

    messageService.setPage = function (page) {
        this.filters.page = page;
        this.broadcastUpdateResults();
    };

    messageService.setSortBy = function (key) {
        this.sortBy = key;
        this.setFilters(this.filters);
    };

    messageService.getSelectedMessageIds = function () {
        //pass message eid for delete
        return this.eids;
        /*

        if(this.filters.folderType && this.filters.folderType == 'sent'){
            return this.sentMessageIds;
        }else{
            return this.inMessageIds;
        }
        */
    };

    messageService.checkAllCheckboxes = function (checked) {
        $rootScope.$broadcast('checkUncheck', checked);
    };

    messageService.setPaginationVariables = function (args) {
        this.total = args.total;
        this.page = args.page;
        this.pageSize = args.pageSize;
        this.broadcastResultCount();
    };

    // set up by the filter controller. Used for setting the left panel filters.
    messageService.setDeleteFilters = function (args) {
        var _args = {};
        _args.inbox = true;
        if (($.trim(this.filters.folderType) === 'sent')) {
            _args.inbox = false;
        }
        //_args.delete = args.delete;
        //_args.action = 'delete';
        _args.eids = args.eids;
        _args.url = CONST.Urls.deleteMessages;
        _args.type = 'POST';
        var _getMessages = getMessages(_args);
        _getMessages.then(function (results) {
            $rootScope.$broadcast('deleteResults', results.data);
        });
    };

    // set up by the filter controller. Used for setting the left panel filters.
    messageService.setFilters = function (args) {
        this.broadcastPageReinitialization();
        this.page = 0;
        this.inbox = true;
        this.filters = angular.copy(args);
        if (($.trim(this.filters.messageType) === '')) {
            delete this.filters.messageType;
        }

        if (($.trim(this.filters.state) === '')) {
            delete this.filters.state;
        }
        if (($.trim(this.filters.folderType) === 'sent')) {
            this.filters.inbox = false;
            messageService.toFrom = 'To';
        } else {
            messageService.toFrom = i18n.FROM;
        }
        if (($.trim(this.filters.folderType) === '')) {
            delete this.filters.folderType;
        }
        if ($.trim(this.sortBy) !== '') {
            this.filters.sortBy = this.sortBy;
        }
        this.broadcastUpdateResults();
    };

    // broadcast the message to the header controller .
    messageService.broadcastResultCount = function () {
        $rootScope.$broadcast('paginationBroadcast');
    };

    messageService.broadcastPageReinitialization = function () {
        $rootScope.$broadcast('reinitializePage');
    };
    messageService.broadcastUpdateResults = function () {
        $rootScope.$broadcast('updateMessages');
    };

    return messageService;
}]);
angular.module('AppCtrl.directive', ['JV.Core.Directives', 'jv.Common.Loading', 'jv.Common.Modal'])
    .value('modalTemplateUrl', 'htm/common/modal.html');

angular.module('AppCtrl.filter', ['jv.Common.Filters']);

// main module.
var messageAppCtrl = angular.module('AppCtrl', ['AppCtrl.service', 'AppCtrl.filter', 'AppCtrl.directive', 'ngRoute']);
messageAppCtrl.config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/history/:jvFolder/:jvMsgType/:jvState/:jvPage', {
            template: 'History',
            controller: 'MessageNewCtrl'
        });
    }]);

/*************************************************************/
/******************** Controllers ****************************/
/*************************************************************/

messageAppCtrl.controller('MessageCtrl', ['$scope', 'messageService', '$location', 'jvContextualLoadingService',
// Application controller
function ($scope, messageService, $location, jvContextualLoadingService) {
    messageService.ifURLFilterOn = false;
    if ($location.path() === '') {
        var args = {};
        args.inbox = true;
        messageService.getMessageTypes(args);
        messageService.getMessageList();
    }

    $scope.isStartDisabled = function(start) {
        return start <= 1;
    };

    $scope.$root.$watch('showProcessingWindow', function (val) {
        if (val) {
            jvContextualLoadingService.show('gridLoader');
        } else {
            jvContextualLoadingService.hide('gridLoader');
        }
    });
}]);


messageAppCtrl.controller('MessageNewCtrl', ['$scope', 'messageService', '$routeParams', '$location',
function ($scope, messageService, $routeParams, $location) {
    var args = {};
    args.inbox = ($routeParams.jvFolder === 'sent') ? false : true;
    messageService.ifURLFilterOn = true;
    messageService.getMessageTypes(args);
    $scope.$on('callWithFilters', function () {
        /* Setting $location.path empty because url based filtering is not implemented for Messages.
         * If parameters are retained in the url then filtering does not work.
         */
        $location.path('');
        messageService.getNewMessages($routeParams);
    });

}]);


messageAppCtrl.controller('MessageFilterCtrl', ['$scope', 'closeFilter', 'openFilter', 'messageService', '$rootScope', '$filter',
// Filter controller
function ($scope, closeFilter, openFilter, messageService, $rootScope, $filter) {
    $scope.changedFolderType = true;
    $scope.folderTypeOptions = [{
        id: 'inbox',
        text: i18n.INBOX
    }, {
        id: 'sent',
        text: i18n.SENT_ITEMS
    }];
    $scope.messageStateOptions = [{
        id: 'n',
        text: i18n.NEW
    }, {
        id: 'u',
        text: i18n.UNREAD
    }, {
        id: 'r',
        text: i18n.REQUIRES_ACTION
    }];

    var makeFilterCall = true;
    var jvPage = 0;
    var jvFolder = 'inbox';
    $scope.noFilter = true;
    $scope.closeFilter = function () {
        closeFilter();
    };
    $scope.openFilter = function () {
        openFilter();
    };

    $scope.reset = function () {
        $scope.filterObject = {};
        $scope.filterObject.folderType = '';
        $scope.filterObject.inbox = true;
        $scope.filterObject.messageType = '';
        $scope.filterObject.state = '';
    };

    function showMessage(message) {
        $('#jv-successMessage').show();
        $('#jv-successMessage').text(message).slideDown(100).delay(4000).slideUp(100);
    }

    var _messageTypes = [];
    $scope.$on('messageTypes', function (event, results) {
        _messageTypes = [];
        if (typeof results != 'undefined' && !!results.resultList) {
            var i = 0;
            angular.forEach(results.resultList, function (item) {
                _messageTypes[i] = {
                    'id': item.key,
                    'text': item.value
                };
                i++;
            });
        }
        $scope.messageTypeOptions = $filter('orderBy')(_messageTypes, 'text');
        if ($scope.makeSetFilterCall === true) {
            $rootScope.$broadcast('callSetFilter');
        }
        $rootScope.$broadcast('callWithFilters');
    });

    $scope.$on('messageResults', function () {
        $scope.changedFolderType = true;
    });

    $scope.filterObject = {};
    $scope.filterObject.folderType = '';
    $scope.filterObject.inbox = true;
    $scope.filterObject.state = '';
    $scope.filterObject.messageType = '';




    $scope.$on('deleteResults', function (event, results) {
        if (results.bean.statusCode === 200) {
            showMessage(i18n['JV_MESSAGE_DELETE']);
            $rootScope.refresh = true;
            messageService.getMessageList();
            window.setTimeout(function () {
                $rootScope.refresh = false;
            }, 15000);
        } else {
            showMessage('An error occured while deleting message(s).');
        }
    });

    $scope.$on('filterValues', function (event, results) {
        $scope.filterObject.folderType = results.jvFolder;
        $scope.filterObject.state = results.jvState;
        $scope.filterObject.messageType = results.jvMsgType;
        var _args = angular.copy($scope.filterObject);
        _args.page = jvPage = results.jvPage;
        _args.inbox = jvFolder = (results.jvFolder === 'sent') ? false : true;
        messageService.setFilters(_args);
    });


    $scope.$on('callSetFilter', function () {
        var _args = $scope.saveArgs;
        _args.messageType = $scope.filterObject.messageType = '';
        if ($scope.filterObject.folderType === 'sent') {
            _args.state = $scope.filterObject.state = '';
        }
        messageService.setFilters(_args);
    });

    $scope.$watch('filterObject', function (newValue, oldValue) {

        messageService.state = $scope.filterObject.state;
        messageService.messageType = $scope.filterObject.messageType;
        if (makeFilterCall === true) {
            if ($.trim($scope.filterObject.folderType) === '' && $.trim($scope.filterObject.messageType) === '' && $.trim($scope.filterObject.state) === '') {
                $scope.noFilter = true;
            }
            if (angular.equals(newValue, oldValue)) {
                return;
            }
            $scope.noFilter = false;
            var _args = angular.copy($scope.filterObject);
            if (messageService.ifURLFilterOn === true) {
                _args.page = jvPage;
                _args.inbox = (jvFolder === 'sent') ? false : true;
            }

            if (newValue.folderType !== oldValue.folderType) {
                var typeArgs = {};
                typeArgs.inbox = (newValue.folderType === 'sent') ? false : true;
                $scope.saveArgs = _args;
                $scope.makeSetFilterCall = true;
                messageService.getMessageTypes(typeArgs);
                $scope.changedFolderType = false;
            }
            if ($scope.changedFolderType === true) {
                messageService.setFilters(_args);
            }
        }
    }, true);

}]);

messageAppCtrl.controller('MessageHeaderCtrl', ['$scope', 'messageService', '$rootScope', 'CONST',
// Header controller
function ($scope, messageService, $rootScope) {

    $scope.start = $scope.end = $scope.total = $scope.totalPages = 0;
    $scope.page = -1;

    $scope.$on('reinitializePage', function () {
        $scope.page = 0;
        $scope.total = 0;
    });
    if (window.isnextGenUIEnabled === 'true') {
        $scope.$on('messageResults', function () {
            $scope.selection = parseInt($scope.items[0].id);
        });

        $scope.$on('deleteResults', function () {
            $scope.selection = parseInt($scope.items[0].id);
        });

        $scope.$on('resetAfterDelete', function () {
            $scope.selection = parseInt($scope.items[0].id);
        });
    }
    else{
        $scope.$on('messageResults', function () {
            $scope.selection = $scope.items[0];
        });

        $scope.$on('deleteResults', function () {
            $scope.selection = $scope.items[0];
        });

        $scope.$on('resetAfterDelete', function () {
            $scope.selection = $scope.items[0];
        });
    }

    $scope.items = [{
            name: i18n.ACTIONS,
            id: '0'
        },
        {
            name: i18n.DELETE,
            id: '1'
        }
    ];


    if (window.isnextGenUIEnabled === 'true') {
        $scope.sortBy = [{
            name: i18n.NAMEAZ,
            id: '0'
        },
        {
            name: i18n.NAMEZA,
            id: '1'
        },
        {
            name: i18n.SUBJECTAZ,
            id: '2'
        },
        {
            name: i18n.SUBJECTZA,
            id: '3'
        },
        {
            name: i18n.TYPEAZ,
            id: '4'
        },
        {
            name: i18n.TYPEZA,
            id: '5'
        },
        {
            name: i18n.DATE_RECENT,
            id: '6'
        },
        {
            name: i18n.DATE_OLDEST,
            id: '7'
        }
    ];
    $scope.sortSelection = parseInt($scope.sortBy[0].id);
    }
    else{
        $scope.sortBy = [{
            name: i18n.SORTBY,
            id: '0'
        },
        {
            name: i18n.NAMEAZ,
            id: '1'
        },
        {
            name: i18n.NAMEZA,
            id: '2'
        },
        {
            name: i18n.SUBJECTAZ,
            id: '3'
        },
        {
            name: i18n.SUBJECTZA,
            id: '4'
        },
        {
            name: i18n.TYPEAZ,
            id: '5'
        },
        {
            name: i18n.TYPEZA,
            id: '6'
        },
        {
            name: i18n.DATE_RECENT,
            id: '7'
        },
        {
            name: i18n.DATE_OLDEST,
            id: '8'
        }
    ];
        $scope.sortSelection = $scope.sortBy[0];
    }

    if (window.isnextGenUIEnabled === 'true') {
        $scope.change = function () {
            var selectionName = $.trim($scope.items[parseInt($scope.selection)].name);
            if (selectionName !== '' && $scope.selection == '1') {
                if (messageService.getSelectedMessageIds().length > 0) {
                    $('.jv-selectionMsg').addClass('jv-hide');
                    $rootScope.$broadcast('showDeleteDialog');
                } else {
                    $('.jv-selectionMsg').removeClass('jv-hide');
                    $scope.selection = $scope.items[0];
                }
            } else {
                $('.jv-selectionMsg').addClass('jv-hide');
            }
        };
    }
    else{
        $scope.change = function () {
            if ($.trim($scope.selection.name) !== '' && $scope.selection.id == '1') {
                if (messageService.getSelectedMessageIds().length > 0) {
                    $('.jv-selectionMsg').addClass('jv-hide');
                    $rootScope.$broadcast('showDeleteDialog');
                } else {
                    $('.jv-selectionMsg').removeClass('jv-hide');
                        $scope.selection = $scope.items[0];
                }
            }
        };
    }
    if (window.isnextGenUIEnabled === 'true') {
    $scope.sort = function () {
        $('.jv-selectionMsg').addClass('jv-hide');
        if ($scope.sortSelection) {
            var sortByName = $scope.sortBy[$scope.sortSelection].name;
            if (sortByName === 'Name (A-Z)') {
                sortByName = 'Name';
            }
            if (sortByName === 'Name (Z-A)') {
                sortByName = 'NameDesc';
            }
            if (sortByName === 'Subject (A-Z)') {
                sortByName = 'Subject';
            }
            if (sortByName === 'Subject (Z-A)') {
                sortByName = 'SubjectDesc';
            }
            if (sortByName === 'Type (A-Z)') {
                sortByName = 'Type';
            }
            if (sortByName === 'Type (Z-A)') {
                sortByName = 'TypeDesc';
            }
            if (sortByName === 'Date Recent') {
                sortByName = 'DateDesc';
            }
            if (sortByName === 'Date Oldest') {
                sortByName = 'Date';
            }
            messageService.setSortBy(sortByName);
        }
    };
}
else{
    $scope.sort = function () {
        $('.jv-selectionMsg').addClass('jv-hide');
        if ($scope.sortSelection && $scope.sortSelection.name) {
            var sortByName = $scope.sortSelection.name;
            if (sortByName === 'Name (A-Z)') {
                sortByName = 'Name';
            }
            if (sortByName === 'Name (Z-A)') {
                sortByName = 'NameDesc';
            }
            if (sortByName === 'Subject (A-Z)') {
                sortByName = 'Subject';
            }
            if (sortByName === 'Subject (Z-A)') {
                sortByName = 'SubjectDesc';
            }
            if (sortByName === 'Type (A-Z)') {
                sortByName = 'Type';
            }
            if (sortByName === 'Type (Z-A)') {
                sortByName = 'TypeDesc';
            }
            if (sortByName === 'Date Recent') {
                sortByName = 'DateDesc';
            }
            if (sortByName === 'Date Oldest') {
                sortByName = 'Date';
            }
            messageService.setSortBy(sortByName);
        }
    };
}

    function updatePaginationVars() {
        if ($scope.total !== 0) {
            $scope.start = ($scope.page * $scope.pageSize) + 1;
            $scope.end = ($scope.totalPages === $scope.page) ? $scope.total : ($scope.page * $scope.pageSize) + $scope.pageSize;
        } else {
            // total count is zero
            $scope.start = 0;
            $scope.end = 0;
        }
    }

    $scope.$on('paginationBroadcast', function () {
        $scope.total = messageService.total;
        $scope.pageSize = messageService.pageSize;
        $scope.totalPages = Math.ceil($scope.total / $scope.pageSize) - 1;
        $scope.page = messageService.page;
        updatePaginationVars();
    });

    $scope.paginate = function (next) {
        $('.jv-selectionMsg').addClass('jv-hide');
        next = !!next;
        // check if there is no next/previous page.
        if (($scope.total === $scope.end && next) || ($scope.page === 0 && !next)) {
            return;
        }
        messageService.setPage(next ? $scope.page + 1 : $scope.page - 1);
    };
    }])
    .directive('jvSelect2Actions', ['Select2Constants', 'returnObjectFromTextAndArray', '$timeout', function(Select2, $timeout) {
        return {
          restrict: 'A',
          require: ['?ngModel'],
          link: function (scope, element, attr, requires) {
            var ngModel = requires[0];
            var options = angular.copy(window._jvPluginDefaults.select2);
            options.minimumResultsForSearch = -1;
            options.dropdownCssClass = "actions-dropdown";
            options.dropdownParent = "jv-action";
            //options.placeholder = attr.placeholder;
            options.selectOnClose = true;
            element.select2(options);
            scope.sort;
            scope.change;
          }
        }
    
}]);
    
messageAppCtrl.controller('MessageGridCtrl', ['$scope', '$rootScope', 'messageService', 'CONST', '$http',
// Grid controller
function ($scope, $rootScope, messageService, CONST, $http) {
    $scope.messages = [];
    $rootScope.showProcessingWindow = true;
    $scope.resultExists = true;
    $scope.loading = false;
    $scope.messageTypeOptions = [];

    $scope.$on('updateMessages', function () {
        getUpdatedMessages();
    });

    function getUpdatedMessages() {
        $rootScope.showProcessingWindow = true;
        messageService.getMessageList();
    };

    $scope.subjectClicked = function (selectedindex) {
        $rootScope.showProcessingWindow = true;
        messageService.selectedindex = selectedindex;
        messageService.getMessagesDetails();
    };

    $scope.$on('deleteResults', function (event, results) {
        performCheckUncheck(false);
    });

    $scope.$on('resetAfterDelete', function () {
        performCheckUncheck(false);
    });

    function performCheckUncheck(checked) {
        var _length = $scope.messages.length;
        for (var i = 0; i < _length; i++) {
            $scope.messages[i].checked = checked;
        }
    }
    $scope.$watch('checkAll', function () {
        messageService.checkAllCheckboxes($scope.checkAll);
    });

    $scope.$on('checkUncheck', function (event, checked) {
        performCheckUncheck(checked);
    });


    function updateTheMessages(results, inbox) {
        $('.jv-selectionMsg').addClass('jv-hide');
        var _backupResults = [];
        $scope.resultExists = true;
        $scope.loading = false;
        $scope.messages = [];
        $scope.toFrom = messageService.toFrom;
        $scope.pageFactor = results.page * results.pageSize;

        messageService.setPaginationVariables({
            total: parseInt((!!results.count ? results.count : 0)),
            pageSize: parseInt((!!results.pageSize ? results.pageSize : 10)),
            page: parseInt((!!results.page ? results.page : 0))
        });

        if (typeof results.userMessages != 'undefined' && results.userMessages.length) {
            _backupResults = results.userMessages;
            for (var i = 0, j = _backupResults.length; i < j; i++) {
                $scope.messages[i] = results.userMessages[i];
                if (!$scope.messages[i].name && $scope.messages[i].name === null) {
                    $scope.messages[i].name = 'System';
                }
                if ($.trim($scope.messages[i].subject) === '') {
                    $scope.messages[i].subject = '<no subject>';
                }
                $scope.messages[i].checked = false;
                $scope.messages[i].id = i + $scope.pageFactor;
                $scope.resultExists = true;
                $scope.loading = true;
                if (!inbox) {
                    $scope.messages[i].read = true;
                }
            }
        } else {
            $scope.resultExists = false;
        }
        $rootScope.showProcessingWindow = false;
    }

    function sendMessageDetails(results) {
        if (typeof results.resultList != 'undefined' && results.resultList.length) {
            var _messageids = results.resultList;
            var _totalCount = results.count;
            var _selectedIndex = messageService.selectedindex;
            var _inbox = messageService.filters.inbox;
            var _messagetype = messageService.messagetype;
            var _state = messageService.state;
            switch (_state) {
                case 'n':
                    _state = 1;
                    break;
                case 'u':
                    _state = 2;
                    break;
                case 'r':
                    _state = 3;
                    break;
                default:
                    _state = 0;
                    break;
            }
            var json = {
                messageids: _messageids,
                totalCount: _totalCount,
                selectedindex: _selectedIndex,
                inbox: _inbox ? 1 : 0,
                messagetype: 'All',
                state: _state,
                pv: messageService.page
            };
            var _mainJson = {
                viewmessagerequest: json
            };
            var resultList = JSON.stringify(_mainJson);
            $('#jv-postData').val(resultList);
            $('#jv-viewMessageForm').submit();
        }
        //$rootScope.showProcessingWindow = false;
    }

    $scope.$on('messageDetailResults', function (event, results) {
        $scope.checkAll = false;
        sendMessageDetails(results);
    });


    $scope.$on('messageResults', function (event, results, inbox) {
        $scope.checkAll = false;
        updateTheMessages(results, inbox);
    });

    $scope.$watch('messages', function (newValue, oldValue) {
        messageService.inMessageIds = [];
        messageService.sentMessageIds = [];
        messageService.eids = [];
        if ($.trim(newValue) !== '' && $.trim(oldValue) !== '') {
            for (var i = 0; i < $scope.messages.length; i++) {
                if (newValue[i].checked === true) {
                    messageService.inMessageIds.push(newValue[i].receivedMessageEId);
                    messageService.eids.push(newValue[i].EId);
                    messageService.sentMessageIds.push(newValue[i].messageEId);
                }
            }
        }
    }, true);

}]);

messageAppCtrl.controller('MessageOverlayController', ['$scope', '$rootScope', 'messageService', 
function ($scope, $rootScope, messageService) {

    $scope.ifDeleteVisible = false;

    $scope.$on('showDeleteDialog', function () {
        $scope.ifDeleteVisible = true;
    });

    $scope.close = function () {
        $scope.ifDeleteVisible = false;
        $rootScope.$broadcast('resetAfterDelete');
    };

    $scope.deleteMessage = function () {
        var args = {};
        args.eids = messageService.getSelectedMessageIds().join(',');
        messageService.setDeleteFilters(args);
        $scope.close();
    };
}]);